import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ComponentsModule} from "../components.module";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    standalone: true,
    imports: [
        ComponentsModule,
        NgIf
    ],
    styleUrl: './header.component.scss'
})
export class HeaderComponent {
    @Input("title")
    title: string;

    @Input("subtitle")
    subtitle: string;

    @Input("backLinkText")
    backLinkText: string;

    @Input() backLinkGtmLabel?: string;

    @Input() showRewardsLogo?: boolean = false;

    @Output("onBackLinkClick")
    onBackLinkClick: EventEmitter<void> = new EventEmitter<void>();

    goBack() {
        this.onBackLinkClick.emit();
    }
}
